module.exports = __webpack_public_path__ + "img/584-42dfb3.png";